import React, { useState, useEffect } from "react";
import useStyles from "../styles";
import config from "../../../config";

// components
import PageTitle from "../../../components/PageTitle";
import InputComponent from "../../partner/components/inputComponent";
import InputSelect from "../../partner/components/inputSelect";
import { CircularProgress } from "@material-ui/core";
import Modal from "../../modals/Modal";

export default function AddGender() {
    const expressions = {
        usuario: /^[a-zA-Z0-9_-]{4,16}$/, // Letras, numeros, guion y guion_bajo
        nombre: /^[a-zA-ZÀ-ÿ\s]{1,40}$/, // Letras y espacios, pueden llevar acentos.
        password: /^.{4,12}$/, // 4 a 12 digitos.
        email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
        numbers: /^[0-9]*$/, // 7 a 14 numeros.
        texto: /^[a-zA-Z0-9 ]{1,500}$/, // Letras
        textNumberAndSymbols: /^[a-zA-ZÀ-ÿ\sS&%'#+-@"!¡¿?()0-9._]+$/i
    }

    const classes = useStyles();

    const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
    const [genderName, setGenderName] = useState({ text: '', valid: null });
    const [genderStatus, setGenderStatus] = useState({ text: '', valid: null });

    const [allStatus, setAllStatus] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const closeModalLogin = e => {
        setShowModal(false);
    }

    const fetchStatus = async () => {
        fetch(baseUrl + "genericStatus",
            {
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
            }).then(response => response.json())
            .then(data => {
                if (data != null) {
                    setAllStatus(data);
                } else {
                    setShowModal(true);
                }
            }).catch(error => null);
    }

    useEffect(() => {
        fetchStatus();
    }, []);

    const onSubmit = async e => {
        e.preventDefault();
        setIsLoading(true);

        if (genderName.valid === 'true' && genderStatus.valid === 'true') {
            const newGender = {
                name: genderName.text, genderStatus: genderStatus.text
            };

            const response = await fetch(baseUrl + "createGender", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
                body: JSON.stringify(newGender)
            });

            const json = await response.json();
            if (json.message == "Ok") {
                setGenderName({ text: '', valid: null });
                setGenderStatus({ text: '', valid: null });
            } else {
                if (json.message == "Access is denied") {
                    setShowModal(true);
                }
            }

            setIsLoading(false);
        } else {
            setIsLoading(false);
        }
    }

    return (
        <div>
            {showModal ? (
                <Modal
                    isOpen={showModal}
                    closeModal={closeModalLogin}
                />
            ) : (
                <></>
            )}
            <PageTitle title="Configuración" />

            <div className={classes.divAddPage} >
                <div className={classes.divTitle}>
                    <label className={classes.titleStyle}>Agregar género</label>
                </div>

                <div className={classes.divColumn} >
                    <InputComponent
                        text={genderName}
                        setPartnerCode={setGenderName}
                        type="text"
                        label="Nombre"
                        name="name"
                        regularExpression={expressions.textNumberAndSymbols}
                        placeholder="Nombre"
                    />

                    <InputSelect
                        text={genderStatus}
                        setValue={setGenderStatus}
                        label={"Estatus"}
                        options={allStatus}
                    />
                </div>

                <div className={classes.divButton}>
                    {isLoading ? (
                        <CircularProgress size={26} className={classes.loginLoader} />
                    ) : (
                        <button
                            className={genderName.valid === 'true' && genderStatus.valid === 'true' ?
                                classes.enableButton : classes.disableButton}
                            onClick={onSubmit}
                        >Agregar</button>
                    )}
                </div>
            </div>
        </div>
    );
}
